import React from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';

import { Text } from 'modules/common';

import * as c from './constants';

function List({ options, type, icon, containerClassName }) {
  return (
    <div className={cn('space-y-ds-12', containerClassName)}>
      {options?.map((item, key) => (
        <div
          className="flex items-center gap-ds-4"
          // eslint-disable-next-line react/no-array-index-key
          key={key}
        >
          <Text color="muted">
            {c.dispatchLeading?.[type]({ index: key, icon })}
          </Text>

          <Text color="muted">{item?.label}</Text>
        </div>
      ))}
    </div>
  );
}

List.defaultProps = {
  options: [],
  type: 'default',
  icon: false,
  containerClassName: '',
};

List.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
    })
  ),
  type: PropTypes.oneOf(Object.keys(c.TYPE_OPTS)),
  icon: PropTypes.oneOfType([PropTypes.bool, PropTypes.instanceOf(Object)]),
  containerClassName: PropTypes.string,
};

export default List;
